import { ReactComponent as Illus } from "assets/images/Illus.svg";
import { useState } from "react";
import { updateUserInviteCode } from "services/apis/apis";
import { ACCESS_TOKEN, getItem } from "local-storage";
import { useAuth } from "contexts/authContext";

function InviteCode() {
  const [val, setVal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);
  const { updateReferrerId } = useAuth();

  const handleProceesCode = async () => {
    try {
      const accessToken = getItem(ACCESS_TOKEN) || "";
      if (!accessToken) return;
      setIsLoading(true);
      await updateUserInviteCode(accessToken, val.trim());
      updateReferrerId("isHadReferrerId");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(true);
    }
  };
  return (
    <div className="min-h-screen flex-1 flex flex-col justify-between w-full h-full p-4">
      <div className="flex flex-col gap-6">
        <Illus className="w-24" />

        <div className="flex flex-col gap-4 text-sm text-slate-300">
          <h2 className="text-2xl text-white">Got an invite code?</h2>
          <p className="">
            Fan.tech is currently in beta. Get an invite code from an existing
            user to sign up.
          </p>
        </div>

        <div className="relative mt-2 flex items-center">
          <input
            placeholder="Enter Invite Code"
            className="w-full py-4 px-[14px] pr-10 border-2 border-slate-700 bg-transparent rounded-xl focus:outline-none text-slate-300 text-sm"
            value={val}
            onChange={(e) => {
              e.preventDefault();
              setVal(e.currentTarget.value);
            }}
          />
        </div>
        {error ? (
          <div className="text-base-content/70 max-w-sm mx-auto mb-6 -mt-2">
            <p className="text-error">
              <i className="fa-solid fa-circle-exclamation mr-2"></i>
              Invalide Code
            </p>
          </div>
        ) : null}
      </div>

      <button
        className="rounded-xl btn w-full bg-secondary uppercase"
        onClick={(e) => {
          e.preventDefault();
          handleProceesCode();
        }}
      >
        {isLoading ? (
          <span className="flex items-center gap-2">
            <i className="loading w-5"></i> SUBMITTING...
          </span>
        ) : (
          "SUBMIT"
        )}
      </button>
    </div>
  );
}

export { InviteCode as default };
